<script setup>
const props = defineProps(['url', 'title', 'description', 'tags', 'terms']);
</script>

<template>
	<a :href="props.url" class="c-card-vacancy" :aria-label="'Lees meer over: ' + props.title">
		<h2 class="heading-md">{{ props.title }}</h2>
		<p>{{ props.description }}</p>

		<div class="c-card-vacancy__tags">
			<ul class="c-tags">
				<template v-for="tag in props.tags">
					<li v-if="tag.showInTags">
						{{ tag.name }}
					</li>
				</template>
			</ul>
			<svg class="icon icon-icon_arrow"><use xlink:href="#icon-icon_arrow"></use></svg>
		</div>
	</a>
</template>
